import { CustomerListItem } from "../customerTilesUtils";
import { atom, useAtom } from "jotai";
import { FLIGHT_CONFIG_QUERY } from "components/DataGetter/FlightConfig/useFlightConfig";
import { useQuery } from "@apollo/client";
import { midgardClients } from "providers/MidgardProvider";

export const allFlightConfigsAtom = atom<Record<string, any>>({});

/** if you're on an internal url & you're a raven user,
 * fetch flight configs for all customers
 * which we can show/filter by on customer tiles page
 */

export function FetchAllFlightConfigs({
  customersList,
}: {
  customersList: CustomerListItem[];
}) {
  return (
    <>
      {customersList.map(({ abbrevName: ckey }) => (
        <SingleFlightConfigQuery key={ckey} {...{ ckey }} />
      ))}
    </>
  );
}

function SingleFlightConfigQuery({ ckey }: { ckey: string }) {
  const [, setAllFlightConfigs] = useAtom(allFlightConfigsAtom);
  useQuery(FLIGHT_CONFIG_QUERY, {
    client: midgardClients.get(ckey),
    fetchPolicy: "cache-first",
    onCompleted: data => {
      if (!data?.flightConfig) {
        console.log(`No flight config found for ${ckey}`);
        return;
      }
      setAllFlightConfigs(prev => ({
        ...prev,
        [ckey]: data?.flightConfig,
      }));
    },
  });
  return null;
}
